import(/* webpackMode: "eager" */ "/vercel/path0/src/app/referral/page.tsx");
